import axios from 'axios';

export const getRegionalSelections = (productId, storeNumber, zipcode) => {
  const baseUrl = window?.__EXPERIENCE_PROPS__?.expConfiguration?.['eleanor-base-url'];
  const path = 'api/regionalization/GetRegionalSelection';
  const payload = { productId, storeId: storeNumber, zipCode: zipcode };

  return axios.post(`${baseUrl}/${path}`, payload)
    .then((response) => response.data)
    .catch((error) => { throw new Error(`API ERROR in ${path} ===>`, error); });
};

export default getRegionalSelections;